<template>
  <div class="m-t-nav">
    <div class="big-m-t">
      <div class="d-f fd-c jc-c ai-c">
        <div class="filter-wrap d-f ai-c tt-up h2">
          <a
            :href="userPlaylists.length === 0 ? '#' : '#playlists'"
            class="m-l d-f ai-c g-half h3"
            @click="
              userPlaylists.length === 0 && (createPlaylistModalOpen = true)
            "
          >
            <span v-if="selectedPlaylist">
              {{ selectedPlaylist.title }}
            </span>
            <span v-else>Create Playlist</span>
            <IconBase v-if="userPlaylists.length" w="20" h="20" color="grey"
              ><IconArrowDown
            /></IconBase>
          </a>
        </div>

        <button
          v-if="selectedPlaylist"
          class="secondary pill mini"
          @click="editingPlaylist = selectedPlaylist"
        >
          Edit
        </button>
      </div>

      <div class="d-f fd-c ai-s m">
        <Playlist
          :playlist-position="0"
          :playlist="playlistData"
          :listType="'songs'"
          :editButtons="false"
          :subTitle="`${selectedPlaylist?.items.length ?? 0} tracks`"
          :key="
            selectedPlaylist
              ? `${selectedPlaylist.id}${selectedPlaylist.items.length}`
              : '.'
          "
          :view="'list'"
        />

        <div v-if="userPlaylists.length === 0" class="empty-list m">
          <p>No playlists created</p>
        </div>

        <div
          v-if="selectedPlaylist && selectedPlaylist.items.length === 0"
          class="empty-list m"
        >
          <p>Playlist is empty</p>
        </div>
      </div>

      <div id="playlists" class="d-f fd-c m ai-c tt-up">
        <p class="mute">Playlists</p>
        <a
          v-for="p in userPlaylists"
          :key="p.id"
          href="#"
          @click="selectedPlaylistId = p.id"
          ><span>{{
            p.title
          }}</span
          >{{ " " }} <span class="mute">({{ p.items.length }})</span></a
        >
        <a href="#" class="" @click="createPlaylistModalOpen = true"
          >Create <span class="mute">(+)</span>
        </a>
      </div>
    </div>

    <CreatePlaylistModal
      :open="createPlaylistModalOpen"
      @close="createPlaylistModalOpen = false"
    />

    <EditPlaylistModal
      :open="!!editingPlaylist"
      :playlist="editingPlaylist"
      @close="editingPlaylist = null"
    />
  </div>
</template>

<script>
import IconArrowDown from "@/assets/icons/IconArrowDown.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import { mapGetters } from "vuex";
import EditPlaylistModal from "@/components/userplaylists/EditPlaylistModal.vue";
import Playlist from "@/components/playlists/Playlist.vue";
import CreatePlaylistModal from "@/components/userplaylists/CreatePlaylistModal.vue";

export default {
  name: "UserPlaylists",
  components: {
    CreatePlaylistModal,
    Playlist,
    EditPlaylistModal,
    IconBase,
    IconArrowDown,
  },
  data() {
    return {
      selectedPlaylistId: "",
      editingPlaylist: null,
      createPlaylistModalOpen: false,
    };
  },
  mounted() {
    this.selectDefaultPlaylist();
  },
  methods: {
    showPlaylist(playlistId) {
      this.selectedPlaylistId = playlistId;
    },
    selectDefaultPlaylist() {
      if (!this.selectedPlaylist && this.userPlaylists.length > 0) {
        this.selectedPlaylistId = this.userPlaylists[0]?.id ?? "";
      }
    },
  },
  computed: {
    ...mapGetters(["userPlaylists"]),

    selectedPlaylist() {
      return this.userPlaylists.find((p) => p.id === this.selectedPlaylistId);
    },

    playlistData() {
      if (this.userPlaylists.length === 0) {
        return {
          songs: [],
        };
      }

      if (!this.selectedPlaylist) {
        return {
          songs: null,
        };
      }

      return {
        songs: this.selectedPlaylist.items.map((item) => item.trackSettings),
      };
    },
  },
  watch: {
    userPlaylists() {
      this.selectDefaultPlaylist();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
</style>
